// import { useLocation } from "react-router-dom"

export default function ClassroomGrid({
  gridData,
  patchApi,
  onStateChange,
  setCurrentStudentNum,
}) {
  return (
    <div className='relative left-0 top-0 z-[900] flex h-full w-full flex-col items-center justify-center overflow-x-auto bg-dimmer-default backdrop-blur-[10px]'>
      <div className='board:pt-100 tab:px-20 tab:pt-64 board:px-48 board:pb-120 board:gap-[14px] flex h-full w-full flex-col items-center justify-center gap-8 px-50 pt-[52px]'>
        {/* <div className='px-12 py-8 border board:px-20 board:py-16 tab:text-body3-medium tab:px-16 tab:py-12 rounded-90 border-border-strong bg-background-default shadow-emphasize'>
          <p className='text-caption2-medium board:text-h1-medium text-label-info'>
            현재 수업 진행중입니다. 판서 또는 보드 편집 시 수업중인 전자칠판에 반영됩니다.
          </p>
        </div> */}
        <div className='board:gap-16 tab:grid-cols-5 tab:grid-rows-4 board:grid-cols-6 board:grid-rows-5 grid h-full w-full grid-cols-6 grid-rows-5 gap-4'>
          {gridData?.map((gridItem, gridIndex) => (
            <div
              key={gridIndex}
              //   state={{
              //     ...data,
              //     studentData: item.student,
              //     gridData: gridData,
              //     currentStudent: item.studentNum,
              //   }}
              onClick={() => {
                if (patchApi) {
                  patchApi(gridItem.studentBoard.id)
                }
                onStateChange()
                setCurrentStudentNum(gridItem.studentNum)
              }}
              // className='box-border h-[178px] w-[314px] overflow-hidden rounded-10 bg-center bg-no-repeat'
              className={`board:rounded-10 board:border-2 relative box-border h-full w-full overflow-hidden rounded-4 border border-solid border-border-strong bg-cover bg-center bg-no-repeat`}
              style={{ backgroundImage: `url(${gridItem.studentBoard.backgroundImageUrl})` }}
            >
              <div className={`h-full w-full hover:bg-dimmer-sub`}>
                <p
                  className={`${gridItem.student.isActive ? 'bg-primary-normal' : 'bg-label-placeholder'} board:left-[14px] board:top-10 board:text-body1-semibold board:px-12 absolute left-6 top-6 rounded-4 px-8 py-4 text-caption-semibold text-static-white shadow-emphasize 3xl:px-12 3xl:text-h1-semibold`}
                >
                  {gridItem.student.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
